import React, {useEffect, useState} from "react";
import FormMap from "./form-map";
import { connect } from "react-redux";
import SlidingPane from "react-sliding-pane";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { getOrganizations } from "../../actions/actions-organizations";
import Organization from "../organization";
import SearchPreview from "../search-preview";

const geolocationOptions = {
    enableHighAccuracy: true,
    timeout: 1000 * 60
};

const Map = props => {

    const {organizations, filtered, currentCountry, getOrganizations, language, wording} = props

    const [browserGeo, setBrowserGeo] = useState(null)

    useEffect(() => {
        getOrganizations();

        const { geolocation } = navigator;

        if (!geolocation) {
            console.log("Geolocation is not supported.");
            return;
        }

        geolocation.getCurrentPosition(
            position => {
                const {latitude, longitude} = position.coords;
                console.log(`Geolocation detected: ${latitude} ${longitude}`)
                setBrowserGeo({lat: latitude, lng: longitude})
            },
            error => console.log(error),
            geolocationOptions)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { width } = useWindowDimensions();

    const [panelOpen, setPanelOpen] = useState(false);
    const [panelItem, setPanelItem] = useState(null);


    const openPanel = (item) => {
        setPanelItem(item);
        setPanelOpen(true)
    }

    const organizationsToDisplay = filtered?.length ? filtered : organizations;

    const centerPoint = (currentCountry && currentCountry.value === 'Беларусь') ? browserGeo || currentCountry : currentCountry;

    return (
        <div className="map">
            <FormMap
                data={organizationsToDisplay}
                centerAddress={centerPoint}
                callback={openPanel}
            />

            <SearchPreview top={width < 600 ? 140 : 80} onClick={openPanel} />

            <SlidingPane
                isOpen={panelOpen}
                title={wording['card_details'][language]}
                width={width < 400 ? '100%' : 400}
                subtitle=""
                onRequestClose={() => {
                    setPanelOpen(false);
                }}>
                <div>
                    {panelItem && <Organization item={panelItem} />}
                </div>
            </SlidingPane>

        </div>
    );

}


const mapStateToProps = ({ data: { organizations, filtered, currentCountry }, language: {language, wording}}) => {
    return { organizations, filtered, currentCountry, language, wording };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrganizations: getOrganizations(dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Map);

